/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/

import { inject, Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { AbstractObjectList } from "@src/app/model/abstract-object";
import { BatchType, ImportParser } from '@src/app/modules/importer/import-page/Import-parser-interface';
import { ImportDoc } from "@src/app/modules/importer/ImportDoc";
import { GeneralParser } from "@src/app/modules/importer/General/GeneralParserService";
import { MessageService } from "@src/app/shared/message.service";

@Injectable({
    providedIn: 'root'
})
export class XeroAllParserService implements ImportParser {

    gps = new GeneralParser();
    msgSvc = inject(MessageService);

    batchType: BatchType = 'XeroExport';

    importDoc: ImportDoc;

    availableImportItems = [];

    xeroPath() {
        return {path: 'everything', needsDate: true};
    }

    setUp() {
        this.importDoc = new ImportDoc();
        return of(true);
    }

    parseRows(): ImportDoc {
        this.msgSvc.show($localize `Export request submitted successfully, refresh page to see if complete or come back in a little while`);
        return this.importDoc;
    }

    postToServer(): Observable<AbstractObjectList> {
        return of(null);
    }
}
